import { render, Component } from "preact";
import $ from "jquery";
import Widget from "./base.js";
import { env } from "tpm-utils";

export class PageViews extends Widget {
	constructor() {
		super();
		this.state = { count: 0 };
	}

	getCount() {
		if (env.isDevelopment()) return Promise.resolve(101);

		return jQuery.ajax({
			type: "GET",
			url: `${document.location.protocol}//api.${document.location.hostname}/page-views/${this.props.featureid}`,
			xhrFields: { withCredentials: true },
		});
	}

	componentWillMount() {
		this.getCount().then((count) => {
			let rounded;
			// between 1000 and 99,999 views
			// round that to the hundreds place
			// then divide by 10 to reduce to a max of 3 digits
			if (count >= 1000 && count < 100000) {
				rounded = Math.ceil(count / 100) / 10;
				rounded = rounded + "k";
				//
			} else if (count >= 100000 && count < 1000000) {
				rounded = Math.ceil(count / 1000);
				rounded = rounded + "k";
				// over a million do similar, but round to the 100-thousands place
			} else if (count >= 1000000 && count < 10000000) {
				rounded = Math.ceil(count / 10000) / 100;
				rounded = rounded + "mil";
				// 10 millions
			} else if (count >= 10000000 && count < 100000000) {
				rounded = Math.ceil(count / 100000) / 10;
				rounded = rounded + "mil";
				// 100 millions
			} else if (count >= 100000000) {
				rounded = Math.ceil(count / 1000000);
				rounded = rounded + "mil";
			} else {
				rounded = count;
			}
			this.setState({ count: rounded });
		});
	}

	renderContent() {
		if (this.state.count) {
			return (
				<div class="ArticleCount">
					<i class="fa fa-signal" aria-hidden="true" />
					<span class="ArticleCount__Number">&nbsp;{this.state.count}</span>
				</div>
			);
		}
	}
}
